import { getPharmacyHandlingMedicines } from '@/utils/graphqlApis';
import { useQuery } from 'react-query';
import useAuth from '../auth/useAuth';
import { MEDICINES_QUERY_KEY } from './queryKeys';
import { parsePharmacyHandlingMedicinesForTable } from '@/parser/medicine';
import { PharmacyHandlingMedicineList } from '@/@types/medicine';

interface Props {
  page: number;
  limit: number;
}
const useGetPharmacyHandlingMedicines = ({ page, limit }: Props) => {
  const { token } = useAuth();
  const { data: medicines } = useQuery(
    MEDICINES_QUERY_KEY.MEDICINE_LIST(page, limit),
    () =>
      getPharmacyHandlingMedicines(
        {
          request: {
            page,
            limit
          }
        },
        token
      ),
    {
      select: parsePharmacyHandlingMedicinesForTable,
      enabled: !!token
    }
  );
  return {
    medicines: medicines ?? ({} as PharmacyHandlingMedicineList)
  };
};

export default useGetPharmacyHandlingMedicines;
